import { FC } from 'react'
import useWindowSize from 'components/util/useWindowSize'
import RightRobotCard from './common/RightRobotCard'
import { TAddon } from 'common/cms-types'
import { Format } from 'common/utils'
import { AddonSlug } from 'common/planSlugs'

type Props = {
  addons: TAddon[]
}

const PrivacyServiceCard: FC<Props> = ({ addons }) => {
  const size = useWindowSize()

  const price =
    (addons.find((v) => v.slug === AddonSlug.DIRECTORS_SERVICE_ADDRESS)?.pricing
      .year_price ?? 0) / 12

  return (
    <RightRobotCard
      image={{
        alt: 'Robot arm pointing left for privacy service',
        desktop: {
          dimensions: {
            height: 364,
            width: 1032,
          },
          src: '/images/new/arm-pointing-left.png',
        },
        mobile: {
          dimensions: {
            height: 231,
            width: 259,
          },
          src: '/images/new/arm-pointing-down-angle.png',
        },
      }}
      imageContainerWidth={'50%'}
      reverseColumnOrder
      overrideAllImageStyles={true}
      imageStyle={{
        maxWidth: '100%',
        objectFit: 'contain',
        top: 20,
      }}
    >
      <div
        className='d-flex flex-column flex-1 px-4 pb-8 py-lg-9 ps-lg-20'
        style={{
          marginRight: size.isLgOrHigher ? '-10%' : '0px',
        }}
      >
        <h2 className='fs-fluid-36-80 lh-105 fw-semibold mb-4 mb-lg-5 me-lg-10'>
          Add even more <span className='color-pink3'>privacy protection</span>.
        </h2>
        <div className='fs-fluid-20-24 lh-140 mt-lg-8 fw-semibold me-lg-n20'>
          With our Full Privacy Service add-on from{' '}
          {Format.money(price)} per month, you can fully protect your home
          address from online visibility. Our cheap virtual office service
          covers you for your registered office address. However, Companies
          House legally requires all directors of UK companies and partners of
          LLP's to register a directors address on public record. This address
          can then be viewed on by the public on the Companies House website.
          <br />
          <br />
          By adding our Full Privacy Service Add-on, you can use our virtual
          office address as your director's address and keep your personal
          details fully hidden from public view.
          <br />
          <br />
          Add our Full Privacy Service to your basket during checkout for only{' '}
          {Format.money(price)} per month.
        </div>
      </div>
    </RightRobotCard>
  )
}

export default PrivacyServiceCard
